import { render, staticRenderFns } from "./AboutInfoSecondary.vue?vue&type=template&id=6ff776a8&scoped=true&"
var script = {}
import style0 from "./AboutInfoSecondary.vue?vue&type=style&index=0&id=6ff776a8&lang=scss&scoped=true&"
import style1 from "./AboutInfoSecondary.vue?vue&type=style&index=1&id=6ff776a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff776a8",
  null
  
)

export default component.exports